import React, { useEffect } from "react";
import { fetchCurrentUser, resetFilters, updateTableData } from "./redux/eventLogsSaga";
import { useDispatch, useSelector } from "react-redux";

import EventLogsTable from "./smartComponents/EventLogsTable";
import ActionsFilterDropdown from "./smartComponents/ActionsFilter";
import SearchFilter from "./smartComponents/SearchFilter";
import TableTypeDropdown from "./smartComponents/TableTypeDropdown";
import DatePicker from "./smartComponents/DatePicker";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import "./eventLogs.scss";

export const EventLogsModule = ({ params }) => {
  const dispatch = useDispatch();
  const { isLoading, filtersDirty } = useSelector((state) => state.eventLogs);

  const handleUpdate = () => {
    return dispatch(updateTableData());
  };

  const handleReset = () => {
    return dispatch(resetFilters(params));
  };

  useEffect(() => {
    dispatch(fetchCurrentUser(params));
  }, []);

  return (
    <div className="event-logs-module" id="settings-light">
      <div className="filters-wrapper">
        <div className="field-container">
          <p>Table type</p>
          <TableTypeDropdown />
        </div>
        <div className="field-container">
          <p>Actions</p>
          <ActionsFilterDropdown />
        </div>
        <div className="field-container search">
          <p>Search</p>
          <SearchFilter />
        </div>
        <div className="field-container date">
          <p>Date</p>
          <DatePicker />
        </div>
        {filtersDirty & !isLoading ? (
          <div className="action-buttons">
            <button className="submit" onClick={() => handleUpdate()}>
              Update
            </button>
            <button className="submit reset" onClick={() => handleReset()}>
              Reset
            </button>
          </div>
        ) : null}
      </div>

      {isLoading ? <LoadingAnimation /> : <EventLogsTable />}
    </div>
  );
};
